import { ElMessageBox, ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message-box/style/css';
import 'element-plus/es/components/message/style/css';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import apis from '@/api';
import { watch, reactive, ref, toRefs } from 'vue';
import SelectPosition from "@/components/SelectPosition.vue";
export default {
  components: {
    SelectPosition
  },
  props: {
    id: String
  },
  setup(props, ctx) {
    const selectPositionRef = ref({});
    const data = reactive({
      assetId: '',
      positions: [],
      posData: []
    });
    const loadData = () => {
      apis.queryAssetPutPosition(data.assetId).then(res => {
        if (res.success) {
          console.log(res.data, "positions");
          data.positions = res.data;
          if (data.positions.length > 0) {
            let flag = false;
            let posId = "";
            data.positions.forEach(value => {
              if (value.posAllName.split("-").indexOf("宣传设计制作物料") == 0) {
                flag = true;
                posId = value.posId;
                return;
              }
            });
            ctx.emit('hasOffline', flag, posId);
          }
        }
      });
      apis.queryPositionTree("").then(res => {
        data.posData = res.data;
      });
    };
    watch(() => props.id, id => {
      data.assetId = id;
      loadData();
    }, {
      immediate: true
    });
    const deletePos = id => {
      ElMessageBox.confirm('确定要删除该可投放点位吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        apis.deleteAssetPutPosition(id).then(res => {
          if (res.success) {
            ElMessage.success("删除成功");
            loadData();
          } else {
            ElMessage.error(res.msg);
          }
        });
      }).catch(() => {
        loadData();
      });
    };
    const addPos = () => {
      selectPositionRef.value.visible();
    };
    const stPosOk = e => {
      console.log(e, "stPosOk");
      let param = {
        assetId: data.assetId,
        posId: e.id
      };
      apis.addAssetPutPosition(param).then(res => {
        if (res.success) {
          ElMessage.success("添加成功");
          loadData();
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    const defaultProps = {
      label: "nodeName",
      value: "id",
      children: "children",
      multiple: false,
      checkStrictly: false,
      leaf: "leaf"
    };
    return {
      ...toRefs(data),
      loadData,
      deletePos,
      defaultProps,
      addPos,
      selectPositionRef,
      stPosOk
    };
  }
};